import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../API/api';

// ===== Thunks =====

// إنشاء طلب ترويج (رفع صورة + حقول)
export const submitPromotion = createAsyncThunk(
  'promotion/submitPromotion',
  async (payload, { rejectWithValue }) => {
    try {
      // payload: { type, platform, video_url, description_text, screenshot(File) }
      const form = new FormData();
      Object.entries(payload).forEach(([k, v]) => form.append(k, v));
      const { data } = await api.post('/promotions', form, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Submit failed');
    }
  }
);

// جلب طلباتي (المستخدم)
export const fetchMyPromotions = createAsyncThunk(
  'promotion/fetchMyPromotions',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/promotions/my', { params });
      return data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Load failed');
    }
  }
);

// جلب قائمة المراجعة (الدعم)
export const fetchPendingPromotions = createAsyncThunk(
  'promotion/fetchPendingPromotions',
  async (params = {}, { rejectWithValue }) => {
    try {
      const { data } = await api.get('/promotions/pending', { params });
      return data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Load failed');
    }
  }
);

// مراجعة طلب (الدعم): قبول/رفض
export const reviewPromotion = createAsyncThunk(
  'promotion/reviewPromotion',
  async ({ id, status, review_reason }, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/promotions/${id}/review`, { status, review_reason });
      return data?.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Review failed');
    }
  }
);

// تنزيل لقطة الشاشة (الدعم)
export const downloadScreenshot = createAsyncThunk(
  'promotion/downloadScreenshot',
  async ({ id, filename }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/promotions/${id}/screenshot`, { responseType: 'blob' });
      // trigger download
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename || `screenshot_${id}.png`;
      a.click();
      window.URL.revokeObjectURL(url);
      return true;
    } catch (err) {
      return rejectWithValue('Download failed');
    }
  }
);

export const fetchPromotionLeaderboard = createAsyncThunk(
  'promotion/fetchPromotionLeaderboard',
  async (params = { metric: 'approved_count', limit: 20 }, { rejectWithValue }) => {
    try {
      // metric: 'approved_count' | 'engagement'
      const query = new URLSearchParams(params).toString();
      const { data } = await api.get(`/promotions/leaderboard?${query}`);
      return { metric: params.metric, rows: data?.data || [] };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Leaderboard load failed');
    }
  }
);
// ===== Slice =====
const promotionSlice = createSlice({
  name: 'promotion',
  initialState: {
    // user
    submitting: false,
    submitError: null,
    myItems: [],
    loadingMine: false,

    // support
    pending: [],
    loadingPending: false,
    reviewLoading: false,
    reviewError: null,
    leaderboard: {
    metric: 'approved_count',
    rows: [],
    loading: false,
    error: null,
  },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // submit
      .addCase(submitPromotion.pending, (s) => { s.submitting = true; s.submitError = null; })
      .addCase(submitPromotion.fulfilled, (s, a) => {
        s.submitting = false;
        if (a.payload) s.myItems.unshift(a.payload);
      })
      .addCase(submitPromotion.rejected, (s, a) => { s.submitting = false; s.submitError = a.payload; })

      // my list
      .addCase(fetchMyPromotions.pending, (s) => { s.loadingMine = true; })
      .addCase(fetchMyPromotions.fulfilled, (s, a) => { s.loadingMine = false; s.myItems = a.payload; })
      .addCase(fetchMyPromotions.rejected, (s) => { s.loadingMine = false; })

      // pending list
      .addCase(fetchPendingPromotions.pending, (s) => { s.loadingPending = true; })
      .addCase(fetchPendingPromotions.fulfilled, (s, a) => { s.loadingPending = false; s.pending = a.payload; })
      .addCase(fetchPendingPromotions.rejected, (s) => { s.loadingPending = false; })

      // review
      .addCase(reviewPromotion.pending, (s) => { s.reviewLoading = true; s.reviewError = null; })
      .addCase(reviewPromotion.fulfilled, (s, a) => {
        s.reviewLoading = false;
        if (a.payload?._id) {
          // أزل من قائمة المعلّق
          s.pending = s.pending.filter((x) => x._id !== a.payload._id);
          // حدّث إن وُجد في قائمتي
          s.myItems = s.myItems.map((x) => (x._id === a.payload._id ? a.payload : x));
        }
      })
      .addCase(reviewPromotion.rejected, (s, a) => { s.reviewLoading = false; s.reviewError = a.payload; })
      .addCase(fetchPromotionLeaderboard.pending, (s) => {
       s.leaderboard.loading = true; s.leaderboard.error = null;
       })
       .addCase(fetchPromotionLeaderboard.fulfilled, (s, a) => {
       s.leaderboard.loading = false;
       s.leaderboard.metric = a.payload.metric;
       s.leaderboard.rows = a.payload.rows;
       })
       .addCase(fetchPromotionLeaderboard.rejected, (s, a) => {
       s.leaderboard.loading = false; s.leaderboard.error = a.payload;
       })
      
  },
});

export default promotionSlice.reducer;
